module.exports = __webpack_public_path__ + "img/wedding_planner.fbfe0bde.png";